exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form[data-v-10c4c680] {\n  padding-top: 1.33333333rem;\n}\nh1[data-v-10c4c680] {\n  color: green;\n  line-height: 1.5em;\n  font-weight: normal;\n  font-size: 0.4rem;\n}\n.row[data-v-10c4c680] {\n  text-align: center;\n  margin: 0 0.53333333rem;\n}\n.the-input[data-v-10c4c680] {\n  display: inline-block;\n}\n.btn[data-v-10c4c680] {\n  background: green;\n  color: #fff;\n  width: 5.33333333rem;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-10c4c680&scoped=true!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/login.vue
// module id = 295
// module chunks = 1